import React from 'react'
import UserNav from '../../Components/Nav/UserNav'

function History() {
    return (
        <div className='container-fluid'>
        <div className="row">
            <div className='col-md-2'>
                    <UserNav />
            </div>
            <div className='col'>
                    user history Page
            </div>
        </div>
            
        </div>
    )
}

export default History
